"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DESIGN_LINES = exports.SHOPS_WITH_STORE_SEARCH = exports.TYPE_FILTER_OPTIONS = exports.AREA_FILTER_OPTIONS = void 0;
exports.AREA_FILTER_OPTIONS = [
    '전국', '서울', '경기', '인천', '강원', '충북', '충남', '세종', '대전',
    '부산', '울산', '대구', '경북', '경남', '광주', '전북', '전남', '제주',
];
exports.TYPE_FILTER_OPTIONS = [
    { text: '대리점', color: 'black' },
    { text: '취급점', color: 'gray' },
    { text: '자전거길', color: 'red' }
];
/** 재고보유 매장안내 기능을 넣을 멀티쇼핑몰 번호 */
exports.SHOPS_WITH_STORE_SEARCH = [1, 15];
exports.DESIGN_LINES = [
    { design: '최상급', name: '최상급 라이딩(폰도)' },
    { design: '상급', name: '상급 라이딩(클럽)' },
    { design: '산악', name: '산악 라이딩(MTB)' },
    { design: '철인', name: '철인3종 경기' },
    { design: '실내', name: '실내 스포츠' },
    { design: '기업', name: '기업 단체복' },
    { design: '키즈', name: '키즈 라이딩' },
];
